import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import LandingPage from "@/components/LandingPage";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/components/admin/AdminDashboard";
import ContentEditor from "@/components/admin/ContentEditor";
import ActivitiesManager from "@/components/admin/ActivitiesManager";
import ScheduleManager from "@/components/admin/ScheduleManager";
import PricingManager from "@/components/admin/PricingManager";
import MonitorsManager from "@/components/admin/MonitorsManager";
import MediaManager from "@/components/admin/MediaManager";
import RegistrationsManager from "@/components/admin/RegistrationsManager";
import ReviewsManager from "@/components/admin/ReviewsManager";
import FaqsManager from "@/components/admin/FaqsManager";
import FormManager from "@/components/admin/FormManager";
import ProtectedRoute from "@/components/admin/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <ContentProvider>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<AdminDashboard />} />
                <Route path="contenido" element={<ContentEditor />} />
                <Route path="actividades" element={<ActivitiesManager />} />
                <Route path="horarios" element={<ScheduleManager />} />
                <Route path="precios" element={<PricingManager />} />
                <Route path="monitores" element={<MonitorsManager />} />
                <Route path="galeria" element={<MediaManager />} />
                <Route path="inscripciones" element={<RegistrationsManager />} />
                <Route path="formulario" element={<FormManager />} />
                <Route path="resenas" element={<ReviewsManager />} />
                <Route path="faqs" element={<FaqsManager />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </ContentProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
